import KTWizard from '../../../../theme/_assets/js/wizard';
import React, { Component } from "react";
import { Button,Card,Breadcrumb,Form,Table,ButtonGroup,ButtonToolbar } from "react-bootstrap";
import Select from 'react-select';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SimpleReactValidator from 'simple-react-validator';
import { toast } from 'react-toastify';
import { Col, CardBody } from "reactstrap";
import { connect } from "react-redux";

var CryptoJS = require("crypto-js");
let key = process.env.REACT_APP_CRYPTO_KEY
var wizard = null;

class CreateConfiguration extends Component {

  constructor(props) {
    super(props);
    this.state = {
		customerType: "",
		customerCode: "",
		parentList: [],
		childList: [],
		parentid: "",
		childid: "",
		note: "",
		disableChild: "",
		minimumLetterNote: "",
		powerBackupDeviceId: "",
		customerCode1:"",
		"customerleademail":"", "customerleadmobile":"", "customerleadenable":"", "partnerleadenable":"", "partnerleademail":"", "partnerleadmobile":"", "customerregenable":"", "customerregemail":"", "customerregemobile":"","partnerregemail":"", "partnerregmobile": "","ordernotificationenable":"", "ordernotificationemail": "", "ordernotificationmobile": "", "drivernotificationenable":"", "drivernotificationemail": "", "drivernotificationmobile": "", "iotenable":"", "iotemail": "", "iotmobile": "", "generalenable":"", "generalemail": "", "generalmobile": "", "partnerregenable":"",
	};
    this.validator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
	this.handleUserFormFields = this.handleUserFormFields.bind(this);
  }

  modalToggle = () => {
    this.setState({ showModal: !this.state.showModal });
  }
  
   nextPath(path) {
    this.props.history.push({ pathname: path });
  }
  
 

  componentDidMount() {
	  
	  

	
	const urls = process.env.REACT_APP_NODE_ENV + "/api/configsetting/fetchall";
    fetch(urls,{
      method:'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(
      response => {
        return response.json();
      }
    ).then(data => {
	
       this.setState({
	    
				customerleademail : data.configdata[0].customer_lead_email,
				customerleadmobile :data.configdata[0].customer_lead_mobile,
				customerleadenable : data.configdata[0].customer_lead_status,
				partnerleademail : data.configdata[0].partner_lead_email,  
				partnerleadmobile: data.configdata[0].partner_lead_mobile, 
				partnerleadenable:  data.configdata[0].partner_lead_status, 
				customerregemail : data.configdata[0].customer_registeration_email,
				customerregemobile : data.configdata[0].customer_registeration_mobile, 
				customerregenable : data.configdata[0].customer_registeration_status, 
				partnerregemail: data.configdata[0].partner_registeration_email,  
				partnerregmobile: data.configdata[0].partner_registeration_mobile, 
				partnerregenable : data.configdata[0].partner_registeration_status , 
				ordernotificationemail : data.configdata[0].order_notification_email,  
				ordernotificationmobile: data.configdata[0].order_notification_mobile, 
				ordernotificationenable :data.configdata[0].order_notification_status , 
				drivernotificationemail :data.configdata[0].driver_notification_email,  
				drivernotificationmobile: data.configdata[0].driver_notification_mobile, 
				drivernotificationenable : data.configdata[0].driver_notification_status , 
				iotemail:data.configdata[0].iotflowmeter_email, 
				iotmobile :data.configdata[0].iotflowmeter_mobile, 
				iotenable : data.configdata[0].iotflowmeter_status, 
				generalemail : data.configdata[0].general_email, 
				generalmobile : data.configdata[0].general_mobile, 
				generalenable : data.configdata[0].general_status,
	   
	   
	   })
    })
	
	
	
  }
  
   oncustomerleadenable = (event) => { 
      this.setState({ customerleadenable: event.target.value })
    }
	partnerleadenable = (event) => { 
      this.setState({ partnerenable: event.target.value })
    } 
	

handleUserFormFields = event => {
	
		switch (event.target.id) {
			case "ucustomerleademail":
				this.setState({ customerleademail: event.target.value });
				break;
			case "ucustomerleadmobile":
				this.setState({ customerleadmobile: event.target.value });
				break;
			case "upartnerleademail":
				this.setState({ partnerleademail: event.target.value });
				break;
			case "upartnerleadmobile":
				this.setState({ partnerleadmobile: event.target.value });
				break;
			case "ucustomerregemail":
				this.setState({ customerregemail: event.target.value });
				break;
			case "ucustomerregemobile":
				this.setState({ customerregemobile: event.target.value });
				break;
			case "upartnerregemail":
				this.setState({ partnerregemail: event.target.value });
				break;
			case "upartnerregmobile":
				this.setState({ partnerregmobile: event.target.value });
				break;
			case "uordernotificationemail":
				this.setState({ ordernotificationemail: event.target.value });
				break;
			case "uordernotificationmobile":
				this.setState({ ordernotificationmobile: event.target.value });
				break;
			case "udrivernotificationemail":
				this.setState({ drivernotificationemail: event.target.value });
				break;
			case "udrivernotificationmobile":
				this.setState({ drivernotificationmobile: event.target.value });
				break;
		    case "uiotemail":
				this.setState({ iotemail: event.target.value });
				break;
			case "uiotmobile":
				this.setState({ iotmobile: event.target.value });
				break;
			case "ugeneralemail":
				this.setState({ generalemail: event.target.value });
				break;
			case "ugeneralmobile":
				this.setState({ generalmobile: event.target.value });
				break;
			
			default:
				break;
		}
	};

 handleEditFormFields = (event) => { 
    this.setState({ childid : event.target.value })
  }
  
handleTextarea = (event) => { 
    this.setState({ note : event.target.value })
	this.setState({ minimumLetterNote: <div class="text-info">Characters: {event.target.value.length}</div> });
  }

   partnerleadenables = (event) => { 
      this.setState({ partnerleadenable: event.target.value })
    } 
	
	 customerregenable = (event) => { 
      this.setState({ customerregenable: event.target.value })
    } 
	  partnerregenable = (event) => { 
      this.setState({ partnerregenable: event.target.value })
    } 
	onordernotificationenable = (event) => { 
      this.setState({ ordernotificationenable: event.target.value })
    } 
	
	ondrivernotifyenable = (event) => { 
      this.setState({ drivernotificationenable: event.target.value })
    } 
	oniotenable = (event) => { 
      this.setState({ iotenable: event.target.value })
    } 
	
	ongeneralenable = (event) => { 
      this.setState({ generalenable: event.target.value })
    } 
	
  createConfiguration = () => {
	 
	 
	
			var postCustData = {
				"customer_lead_email" : this.state.customerleademail,
				"customer_lead_mobile":this.state.customerleadmobile,
				"customer_lead_status": (this.state.customerleadenable === "" ? '1': this.state.customerleadenable), 
				"partner_lead_email":this.state.partnerleademail, 
				"partner_lead_mobile":this.state.partnerleadmobile, 
				"partner_lead_status":(this.state.partnerleadenable === "" ? '1': this.state.partnerleadenable), 
				"customer_registeration_email":this.state.customerregemail, 
				"customer_registeration_mobile":this.state.customerregemobile, 
				"customer_registeration_status":(this.state.customerregenable === "" ? '1': this.state.customerregenable), 
				"partner_registeration_email":this.state.partnerregemail, 
				"partner_registeration_mobile":this.state.partnerregmobile, 
				"partner_registeration_status":(this.state.partnerregenable === "" ? '1' : this.state.partnerregenable) , 
				"order_notification_email":this.state.ordernotificationemail,  
				"order_notification_mobile":this.state.ordernotificationmobile, 
				"order_notification_status":(this.state.ordernotificationenable === "" ? '1' : this.state.ordernotificationenable), 
				"driver_notification_email":this.state.drivernotificationemail,  
				"driver_notification_mobile":this.state.drivernotificationmobile, 
				"driver_notification_status":(this.state.drivernotificationenable === "" ? '1' : this.state.drivernotificationenable), 
				"iotflowmeter_email":this.state.iotemail, 
				"iotflowmeter_mobile":this.state.iotmobile, 
				"iotflowmeter_status":(this.state.iotenable === "" ? '1': this.state.iotenable), 
				"general_email":this.state.generalemail, 
				"general_mobile":this.state.generalmobile, 
				"general_status":(this.state.generalenable === "" ? '1': this.state.generalenable), 
				};
	
		 
	  
		 
			fetch(process.env.REACT_APP_NODE_ENV + '/api/configsetting/create', {
			  method: 'POST',
			  headers: {
				'Content-Type': 'application/json',
				'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
			  },
			  body: JSON.stringify(postCustData)
			}).then((res) => res.json())
			  .then((data) => {
				
				toast.success("Configuration setting  added Successfully!!!", {
				  position: toast.POSITION.TOP_CENTER,
				});
				this.componentDidMount();
			}).catch((err) => console.log(err))
		
	
  }

  

  render() {
	 const customerType = this.state.customerType;
	let parentList = this.state.parentList.map(data => (
        <option key={data.id} value={data.id}>{data.parent_category}</option>
      ))
	
	  
	
		let customerTypeData = [
      { id: "customerType", label: "Apartment Customer", value: "Apartment_Customer" },
           { id: "customerType", label: "Individual Customer", value: "Individual_Customer" },
      { id: "customerType", label: "Corporate Customer", value: "Corporate_Customer" }]
	  
		
	
	  
	let customerData1 = [];
    if (customerType === "Apartment_Customer") {
		if(this.state.apartmentUserInput){
		  this.state.apartmentUserInput.map(data => {
			let sddData = { id: "customerCode", label: data.apartmentName+" ("+data.apartmentId+")", value: data.apartmentId }
			customerData1.push(sddData)
			return null;
		  })
		}
    } else if (customerType === "Corporate_Customer") {
		if(this.state.corporateUserInput){
		  this.state.corporateUserInput.map(data => {
			let sddData = { id: "customerCode", label: data.companyName+" ("+data.corporateId+")", value: data.corporateId }
			customerData1.push(sddData)
			return null;
		  })
		}
    } else if (customerType === "Individual_Customer") {
		if(this.state.individualUserInput){
		  this.state.individualUserInput.map(data => {
			let sddData = { id: "customerCode", label: data.name+" ("+data.individualId+")", value: data.individualId }
			customerData1.push(sddData)
			return null;
		  })
		}
    }
	
    return (<>
      <Breadcrumb>
        <Breadcrumb.Item
          onClick={() => this.nextPath("/config-setting/configuration")}
        >
         Setting 
          </Breadcrumb.Item>

        <Breadcrumb.Item active>Configuration Setting</Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <Modal isOpen={this.state.modal} style={{ width: "1000px", display: "block" }}>
          <Card >
            <Card.Body>
              <ModalHeader>
                Add User
                </ModalHeader>
              <ModalBody>
              </ModalBody>
              <ModalFooter><div className="col-8 float-center">
                <Button variant="outline-primary" onClick={this.userSubmit}> Save </Button>
                &nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={this.userToggle}> Cancel </Button>
              </div>
              </ModalFooter>
            </Card.Body>
          </Card>
        </Modal>
      </div>
      <div>
      </div>

      <div ref={this.KTWizard} className="kt-grid kt-wizard-v1 kt-wizard-v1--white" id="kt_wizard_v1" data-ktwizard-state="step-first">
        <div className="kt-grid__item kt-grid__item--fluid kt-wizard-v1__wrapper">
          <form className="kt-form" id="kt_form" >
            <div className="kt-wizard-v1__content" data-ktwizard-type="step-content" data-ktwizard-state="current">
				<div className="kt-heading kt-heading--md">Configuration Setting</div>
				<div className="kt-form__section kt-form__section--first">
					<div className="kt-wizard-v1__form ">
					  <fieldset style={{ border: "1px solid #c7b6b6", }}>
						<legend style={{ width: "revert", fontSize :12, fontWeight:600 }}>Customer Lead</legend>
						  <div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Enable:</label>
								<div className="col-lg-4 col-xl-4">
									<select name="customerleadenable" id="customerleadenable"  className="form-control" value={this.state.customerleadenable} onChange={this.oncustomerleadenable} >
										<option value="1">Yes</option>
										<option value="0">No</option>
									
									</select>
									{
										this.validator.message('Status Active', this.state.customerleadenable, 'required')
									}
								</div>
							</div>
							<div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Email Address:</label>
								<div className="col-lg-8 col-xl-8">
									 	
									<Form.Control as="textarea" rows="3" id="ucustomerleademail" value={this.state.customerleademail}  onChange={this.handleUserFormFields}/>
									 
									
								</div>
							</div>
							<div className="form-group row"> 
							  <label className="col-lg-3 col-form-label text-lg-right">Mobile Number:</label>
								<div className="col-lg-8 col-xl-8">
								<Form.Control as="textarea" rows="3" id="ucustomerleadmobile" value={this.state.customerleadmobile}   onChange={this.handleUserFormFields}/>
									
									
								</div>
							</div>
						 
						</fieldset>
					
						 <fieldset style={{ border: "1px solid #c7b6b6", }}>
						<legend style={{ width: "revert", fontSize :12, fontWeight:600  }}>Partner Lead</legend>
						  <div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Enable:</label>
								<div className="col-lg-4 col-xl-4">
									<select name="partnerleadenable" id="upartnerleadenable"  className="form-control" value={this.state.partnerleadenable} onChange={this.partnerleadenables} >
										<option value="1">Yes</option>
										<option value="0">No</option>
									
									</select>
									{
										this.validator.message('Status Active', this.state.partnerleadenable, 'required')
									}
								</div>
							</div> 
							<div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Email Address:</label>
								<div className="col-lg-8 col-xl-8">
								<Form.Control as="textarea" rows="3" id="upartnerleademail" value={this.state.partnerleademail} onChange={this.handleUserFormFields}/>
									 
									
								</div>
							</div>
							<div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Mobile Number:</label>
								<div className="col-lg-8 col-xl-8">
								<Form.Control as="textarea" rows="3" id="upartnerleadmobile" value={this.state.partnerleadmobile}  onChange={this.handleUserFormFields}/>
									 
									
								</div>
							</div>
						
						</fieldset>
						
					 
					 
						 <fieldset style={{ border: "1px solid #c7b6b6", }}>
						<legend style={{ width: "revert", fontSize :12, fontWeight:600  }}>Customer Registration</legend>
						  <div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Enable:</label>
								<div className="col-lg-4 col-xl-4">
									<select name="customerregenable" id="customerregenable"  className="form-control" value={this.state.customerregenable} onChange={this.customerregenable} >
										<option value="1">Yes</option>
										<option value="0">No</option>
									
									</select>
									{
										this.validator.message('Status Active', this.state.customerleadenable, 'required')
									}
								</div>
							</div>
							<div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Email Address:</label>
								<div className="col-lg-8 col-xl-8">
									
									 <Form.Control as="textarea" rows="3"  id="ucustomerregemail" value={this.state.customerregemail}  onChange={this.handleUserFormFields}/>
									
								</div>
							</div>
							<div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Mobile Number:</label>
								<div className="col-lg-8 col-xl-8">
								    <Form.Control as="textarea" rows="3"  id="ucustomerregemobile" value={this.state.customerregemobile}  onChange={this.handleUserFormFields}/>
									
									
								</div>
							</div>
						
						</fieldset>
						 			
									{/* <!--		 <fieldset style={{ border: "1px solid #c7b6b6", }}>
						<legend style={{ width: "revert", fontSize :12, fontWeight:600 }}>Partner Registration</legend>
						  <div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Enable:</label>
								<div className="col-lg-4 col-xl-4">
									<select name="partnerregenable" id="upartnerregenable"  className="form-control" value={this.state.partnerregenable} onChange={this.partnerregenable} >
										<option value="1">Yes</option>
										<option value="0">No</option>
									
									</select>
									{
										this.validator.message('Status Active', this.state.customerleadenable, 'required')
									}
								</div>
							</div>
							<div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Email Address:</label>
								<div className="col-lg-8 col-xl-8">
									
									  <Form.Control as="textarea" rows="3"  id="upartnerregemail"  value={this.state.partnerregemail}  onChange={this.handleUserFormFields}/>
									
								</div>
							</div>
							<div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Mobile Number:</label>
								<div className="col-lg-8 col-xl-8">
								 <Form.Control as="textarea" rows="3"  id="upartnerregmobile" value={this.state.partnerregmobile}  onChange={this.handleUserFormFields}/>
									 
									
								</div>
							</div>
						
									</fieldset>   --> */ }
									
						
						<fieldset style={{ border: "1px solid #c7b6b6", }}>
						<legend style={{ width: "revert", fontSize :12, fontWeight:600  }}>Order Notification</legend>
						  <div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Enable:</label>
								<div className="col-lg-4 col-xl-4">
									<select name="ordernotificationenable" id="ordernotificationenable"  className="form-control" value={this.state.ordernotificationenable} onChange={this.onordernotificationenable} >
										<option value="1">Yes</option>
										<option value="0">No</option>
									
									</select>
									{
										this.validator.message('Status Active', this.state.customerleadenable, 'required')
									}
								</div>
							</div>
							<div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Email Address:</label>
								<div className="col-lg-8 col-xl-8">
								     <Form.Control as="textarea" rows="3"  id="uordernotificationemail" value={this.state.ordernotificationemail}  onChange={this.handleUserFormFields}/>
									
									
								</div>
							</div>
							<div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Mobile Number:</label>
								<div className="col-lg-8 col-xl-8">
								     <Form.Control as="textarea" rows="3"  id="uordernotificationmobile" value={this.state.ordernotificationmobile}  onChange={this.handleUserFormFields}/>
									
									
								</div>
							</div>
						
						</fieldset>
						
						
						<fieldset style={{ border: "1px solid #c7b6b6", }}>
						<legend style={{ width: "revert", fontSize :12, fontWeight:600  }}>Driver Notification</legend>
						  <div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Enable:</label>
								<div className="col-lg-4 col-xl-4">
									<select name="drivernotificationenable" id="drivernotificationenable"  className="form-control" value={this.state.drivernotificationenable} onChange={this.ondrivernotifyenable} >
										<option value="1">Yes</option>
										<option value="0">No</option>
									
									</select>
									{
										this.validator.message('Status Active', this.state.customerleadenable, 'required')
									}
								</div>
							</div>
							<div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Email Address:</label>
								<div className="col-lg-8 col-xl-8">
									 <Form.Control as="textarea" rows="3"  id="udrivernotificationemail" value={this.state.drivernotificationemail}  onChange={this.handleUserFormFields} />
									
								</div>
							</div>
							<div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Mobile Number:</label>
								<div className="col-lg-8 col-xl-8">
								    <Form.Control as="textarea" rows="3"  id="udrivernotificationmobile" value={this.state.drivernotificationmobile}  onChange={this.handleUserFormFields} />
									 
									
								</div>
							</div>
						
						</fieldset>
						
					
					<fieldset style={{ border: "1px solid #c7b6b6", }}>
						<legend style={{ width: "revert", fontSize :12, fontWeight:600  }}>IOT Flow Meter</legend>
						  <div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Enable:</label>
								<div className="col-lg-4 col-xl-4">
									<select name="iotenable" id="iotenable"  className="form-control" value={this.state.iotenable} onChange={this.oniotenable} >
										<option value="1">Yes</option>
										<option value="0">No</option>
									
									</select>
									{
										this.validator.message('Status Active', this.state.customerleadenable, 'required')
									}
								</div>
							</div>
							<div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Email Address:</label>
								<div className="col-lg-8 col-xl-8">
								<Form.Control as="textarea" rows="3" id="uiotemail" value={this.state.iotemail}  onChange={this.handleUserFormFields}  />
									
									
								</div>
							</div>
							<div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Mobile Number:</label>
								<div className="col-lg-8 col-xl-8">
								<Form.Control as="textarea" rows="3" id="uiotmobile" value={this.state.iotmobile}  onChange={this.handleUserFormFields}  />
								
								
									
								</div>
							</div>
						
						</fieldset>
						
						<fieldset style={{ border: "1px solid #c7b6b6", }}>
						<legend style={{ width: "revert", fontSize :12, fontWeight:600  }}>General Contact</legend>
						  <div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Enable:</label>
								<div className="col-lg-4 col-xl-4">
									<select name="generalenable" id="generalenable"  className="form-control" value={this.state.generalenable} onChange={this.ongeneralenable} >
										<option value="1">Yes</option>
										<option value="0">No</option>
									
									</select>
									{
										this.validator.message('Status Active', this.state.customerleadenable, 'required')
									}
								</div>
							</div>
							<div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Email Address:</label>
								<div className="col-lg-8 col-xl-8">
								<Form.Control as="textarea" rows="3" id="ugeneralemail" value={this.state.generalemail}  onChange={this.handleUserFormFields} />
								
									 
									
								</div>
							</div>
							<div className="form-group row">
							  <label className="col-lg-3 col-form-label text-lg-right">Mobile Number:</label>
								<div className="col-lg-8 col-xl-8">
								<Form.Control as="textarea" rows="3" id="ugeneralmobile" value={this.state.generalmobile}  onChange={this.handleUserFormFields} />
									 
									
								</div>
							</div>
						
						</fieldset>
					
					
					
					
					
					
					
					
					,
					
		
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
						
						

						
				
						
						
					</div>
				</div>
            </div>
			
            <div className="kt-form__actions" style={{float: "right"}}>
                <Button variant="outline-primary" onClick={() => this.createConfiguration()} style={{ margin: "0px 5px "}} > Save </Button>
                
            </div>

            {/* <!--end: Form Actions --> */}
          </form>

          {/* <!--end: Form Wizard Form--> */}
        </div>
      </div>
    </>
    );
  }
} 


const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id
  }
}

export default connect(
  mapStateToProps,
  null
)(CreateConfiguration)